#import "../../../common/graphql/NotesEntityFields.graphql"
query NotesApprovalHistory($id: UUID!) {
  approvalHistory(id: $id) {
    id
    notesByEntityId(orderBy: _CREATED_DATE_DESC)  {
      nodes {
        ...NotesEntityFields
      }
    }
  }
}
